<template>
    <div class="row">
        <div class="col-12 col-lg-6 reg-size-form pt-3 pb-4 mt-0 mt-lg-5">
            <div v-if="showTitle || showSubTitle">
                <h1 class="text-white mb-0 mb-sm-3" v-if="showTitle">{{ title }}</h1>
                <p class="mb-2" v-if="showSubTitle">Order the right tyres for your car using your registration</p>
            </div>
            <reg-form :postcode="postcode" :image-base-path="imageBasePath"></reg-form>
            <p class="pt-3">Or enter tyre size</p>
            <size-form :postcode="postcode" :options="options"></size-form>
            <a :href="this.baseUrl + '/calculate-your-tyre-size'" class="text-white w-auto text-underline small" target="_blank">Where do I find my tyre size?</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['options', 'postcode', 'imageBasePath', 'showTitle', 'showSubTitle'],
        data() {
            return {
                title: 'Find the perfect fit',
            }
        },
        mounted() {
        },
        methods: {

        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .reg-size-form {
        background: #00A68F;
        color: #fff;
        border-left: 7px solid #DC453A;
        padding-left: 15px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        z-index: 10;
        @media screen and (min-width: 1200px) {
            box-shadow: 0 6px 6px -3px rgba(0,0,0,0.20), 0 10px 14px 1px rgba(0,0,0,0.14), 0 4px 18px 3px rgba(0,0,0,0.12);
            max-width: 570px;
        }
        .sub-heading, h3 {
            text-align: left;
            font-size: 16px;
        }
        p, label {
            color: inherit;
        }
        button {
            p {
                font-weight: 400;
            }
        }
    }
</style>